/**
 * Subcampos de sistema de una referencia: existen en todo documento dinámico pero no
 * figuran en su definición, así que el selector de columnas no los ve al expandir la
 * referencia. Hoy solo el ID (`idModel`), el número que el back asigna con un contador
 * al crear el documento (dynamicModelController) y que el listado muestra como «ID».
 *
 * Tipo `autoincrement` y no `number`: el valor se muestra tal cual, sin separador de
 * miles ni decimales.
 */
export const REFERENCE_ID_SUBFIELD = Object.freeze({
  key: "idModel",
  label: "ID",
  type: "autoincrement",
});

const REFERENCE_SYSTEM_SUBFIELDS = [REFERENCE_ID_SUBFIELD];

/** Definición de un subcampo de sistema por key, o null si no lo es. */
export function findReferenceSystemSubField(key) {
  return REFERENCE_SYSTEM_SUBFIELDS.find((f) => f.key === key) || null;
}

/**
 * Campos de la definición referenciada + los de sistema que la definición no declara,
 * ordenados por etiqueta.
 */
export function withReferenceSystemSubFields(fields) {
  const keys = new Set((fields || []).map((f) => f.key));
  const extras = REFERENCE_SYSTEM_SUBFIELDS.filter((f) => !keys.has(f.key)).map(
    (f) => ({ ...f })
  );
  return [...(fields || []), ...extras].sort((a, b) =>
    (a.label || a.key).toLowerCase().localeCompare((b.label || b.key).toLowerCase())
  );
}
